import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneNumberFormat'
})
export class PhoneNumberFormatPipe implements PipeTransform {

  transform(value: string): string {
    if (value === null || value === '') {
      return null;
    }
    const phoneNumber = '' + value;
    if (phoneNumber.length == 10) {
      return (
        '+1' +
        ' (' +
        phoneNumber.slice(0, 3) +
        ') ' +
        phoneNumber.slice(3, 6) +
        '-' +
        phoneNumber.slice(6)
      );
    }
    return phoneNumber;
  }
}
